import { Get, Post } from "../utils/http-utils";

export const getFeaturesForUser = async (queryParams = {}) => {
  return Get("/user-management", queryParams)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getAllUsers = async (queryParams = {}) => {
  return Get("/user-management/user-role", queryParams)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getAllRoles = async (queryParams = {}) => {
  return Get("/user-management/roles", queryParams)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const updateUserRole = async (requestBody) => {
  return Post("/user-management/user-role", requestBody)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error("Update user role failed:", err);
      throw err;
    });
};

export const getAllfeatures = async (queryParams = {}) => {
  return Get("/user-management/features", queryParams)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getRolefeatures = async (queryParams = {}) => {
  return Get("/user-management/role-feature", queryParams)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const updateRoleFeatures = async (requestBody) => {
  try {
    const data = await Post("/user-management/role-feature", requestBody);
    return data;
  } catch (err) {
    console.error("Update role features failed:", err);
    throw err;
  }
};


export const postLoginLogout = async (requestBody) => {
  return Post("/audit-login-logout", requestBody)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};